// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".optimum-proposal .el-form-item__label{color:#002948;font-size:14px}.optimum-proposal input{border-radius:0!important}", ""]);
// Exports
module.exports = exports;
